"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operation = void 0;
var operation_event_1 = require("@augloop/tracelogger/dist/src/operation-event");
var now_1 = require("./now");
var Operation = /** @class */ (function (_super) {
    __extends(Operation, _super);
    function Operation(properties, clientMetadata, userContext) {
        var _this = _super.call(this, properties) || this;
        _this.eventName = 'Operation';
        if (!properties || properties.count == undefined) {
            _this.count = 1;
        }
        if (clientMetadata) {
            _this.setClientMetadata(clientMetadata);
        }
        if (userContext) {
            _this.setUserContext(userContext);
        }
        return _this;
    }
    Operation.prototype.setClientMetadata = function (clientMetadata) {
        if (clientMetadata) {
            this.clientAppName = clientMetadata.appName;
            this.clientAppPlatform = clientMetadata.appPlatform;
            this.clientAppVersion = clientMetadata.appVersion;
            this.clientFlights = clientMetadata.flights;
            this.clientReleaseAudienceGroup = clientMetadata.releaseAudienceGroup;
            this.clientReleaseChannel = clientMetadata.releaseChannel;
            this.clientReleaseFork = clientMetadata.releaseFork;
            this.clientRuntimeVersion = clientMetadata.runtimeVersion;
            this.clientSessionId = clientMetadata.sessionId;
            this.clientDeviceId = clientMetadata.deviceId;
        }
    };
    Operation.prototype.setUserContext = function (userContext) {
        if (userContext) {
            // please ensure fields assigned here match those in userContextFieldNames in geneva-trace-logger.ts
            this.userId = userContext.puid || userContext.oid;
            this.userType = userContext.userType && userContext.userType.toString();
        }
    };
    Operation.prototype.start = function () {
        this.startTime = now_1.now();
        return this;
    };
    Operation.prototype.stop = function () {
        var stopTime = now_1.now();
        this.durationMs = Math.round(stopTime - this.startTime);
        return this;
    };
    return Operation;
}(operation_event_1.OperationEvent));
exports.Operation = Operation;
//# sourceMappingURL=operation.js.map